import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

import { titleProps } from '../common/helpers/title-props';

export function LiberisCheckYourDataTitle() {
  const { t } = useTranslation();

  return (
    <Typography {...titleProps}>
      {t('welcomePage.loanApplicationPossible.liberis.checkYourData.title')}
    </Typography>
  );
}
